export const billingItemId = (item) => {
    const id = Number(item.ItemID);
    return Number.isSafeInteger(id) && id > 0 ? id : null;
};

export const sameBillingItem = (left, right) => {
    const id = billingItemId(left);
    return id === null ? left === right : id === billingItemId(right);
};

export const restoreHeldItems = (rows, catalog = []) => rows
    .filter(row => row.item_name)
    .map(row => {
        const id = billingItemId(row);
        const currentItem = id === null ? null : catalog.find(item => billingItemId(item) === id);
        return {
            ...currentItem,
            ItemID: id,
            ItemCategoryID: row.ItemCategoryID ?? currentItem?.ItemCategoryID,
            name: row.item_name,
            Price: Number(row.unitprice) || 0,
            qty: parseInt(row.qty, 10) || 1,
        };
    });
